import React from "react";
import { CSidebarNavTitle } from "@components/template";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import { startGetTeacherLoginUrl } from "@redux/slices/students/moodle";
import { useDispatch, useSelector } from "react-redux";

export const Modules_TeachersSession = () => {
    const dispatch = useDispatch();
    const { hasPermission, hasExtraModule } = useHasPermission();
    const { session, user } = useSelector((state) => state.auth);
    const { tiny_name } = useSelector((state) => state.config);

    const handleMoodleLogin = () => {
        dispatch(startGetTeacherLoginUrl(user.id));
    };

    return (
        <div>
            {hasPermission("TEACHERS_PAYROLL_BY_TEACHERS") && (
                <CSidebarNavTitle>Docentes</CSidebarNavTitle>
            )}
            {session == "teacher" && !!user?.moodle && (
                <NavLinkApp
                    name="Aulas virtuales"
                    onClick={handleMoodleLogin}
                    icon={
                        <IconApp iconClassName="fa-solid fa-graduation-cap c-sidebar-nav-icon" />
                    }
                />
            )}
            {hasPermission("TEACHER_CHECK_IN") && (
                <NavLinkApp
                    name="Reloj checador"
                    to={`/app/teacher/oclock`}
                    icon={
                        <IconApp iconClassName="fas fa-clock c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {hasPermission("TEACHERS_PAYROLL_BY_TEACHERS") && (
                <NavLinkApp
                    name="Nóminas"
                    to={`/app/teacher/cuts/punches`}
                    icon={
                        <IconApp iconClassName="fas fa-file-invoice-dollar c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {hasPermission("TEACHERS_CALENDAR") && (
                <NavLinkApp
                    name={tiny_name == "EAD" ? "Clases" : "Horario"}
                    to={`/app/teacher/schedule`}
                    icon={
                        <IconApp iconClassName="fas fa-solid fa-person-chalkboard c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {/* Grupos docente */}
            {/* {hasPermission("TEACHER_GROUPS") && (
                <NavLinkApp
                    name="Mis grupos"
                    to={`/app/teacher/groups`}
                    icon={
                        <IconApp iconClassName="fas fa-solid fa-screen-users c-sidebar-nav-icon"></IconApp>
                    }
                />
            )} */}

            {/* Materias docente */}
            {/* {hasPermission("TEACHER_SUBJECTS") && (
                <NavLinkApp
                    name="Mis materias"
                    to={`/app/teacher/subjects`}
                    icon={
                        <IconApp iconClassName="fas fa-solid fa-books c-sidebar-nav-icon"></IconApp>
                    }
                />
            )} */}

            {/* Calificaciones docente */}
            {hasPermission("TEACHER_GRADES") && (
                <NavLinkApp
                    name="Calificaciones"
                    to={`/app/teacher/grades/ordinaries`}
                    icon={
                        <IconApp iconClassName="fas fa-solid fa-file-pen c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {/* Extraordinarios docente */}
            {hasPermission("TEACHER_EXTRAORDINARIES") && (
                <NavLinkApp
                    name="Extraordinarios"
                    to={`/app/teacher/grades/extraordinaries`}
                    icon={
                        <IconApp iconClassName="fa-light fa-file-pen c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {/*Asistencias */}
            {hasPermission("TEACHER_ATTENDENCE_BY_STUDENT") && (
                <NavLinkApp
                    name="Toma de asistencias"
                    to={`/app/teacher/attendance`}
                    icon={
                        <IconApp iconClassName="fa-regular fa-clipboard-user c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {/* Avances programáticos */}
            {hasPermission("PROGRAMMATIC_ADVANCE") && (
                <NavLinkApp
                    name="Avances programáticos"
                    to={`/app/teacher/programmatic-advance`}
                    icon={
                        <IconApp iconClassName="fa-solid fa-file-spreadsheet c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {session == "teacher" && (
                <NavLinkApp
                    name="Documentación"
                    to="/teachers/load-documents"
                    icon={
                        <IconApp iconClassName="fa-regular fa-folder-open c-sidebar-nav-icon" />
                    }
                />
            )}

            {/* Eventos academicos */}
            {hasExtraModule("TEACHER_EXTRA_ACADEMIC_EVENTS") && (
                <NavLinkApp
                    name="Eventos académicos"
                    to="/app/academic_events"
                    icon={
                        <IconApp iconClassName="fas fa-calendar-star c-sidebar-nav-icon"></IconApp>
                    }
                />
            )}

            {/* Responder encestas */}
            {hasPermission("TEACHER_ANSWER_SURVEYS") && (
                <NavLinkApp
                    name="Encuestas"
                    to="/my/surveys"
                    icon={
                        <IconApp iconClassName="fa-solid fa-clipboard-list-check  c-sidebar-nav-icon" />
                    }
                />
            )}
        </div>
    );
};
